var _defs, _ellipse, _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1171({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.27,
    cy: 6.76,
    rx: 5.73,
    ry: 5.64
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.21,
    y1: 10.74,
    x2: 1,
    y2: 14.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9,8.26l-.28-2.9V4H9.91V5.36l-.29,2.9ZM8.77,9.74V8.64H9.86v1.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1171);
export default __webpack_public_path__ + "static/media/Symbolpack_1_171.29678e1f5a4fcbe684d7e5191c2b7a4d.svg";
export { ForwardRef as ReactComponent };